import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { actionCreators as tipActionCreators, tipPropTypes } from 'redux/tipHandlers';
import { ROUTES } from 'constants/routes';
import { trackEvent, gaTrackPageView } from 'services/AnalyticsService';
import { categories, actions, labels } from 'constants/analytics';

import TipsScene from './layout';

class TipsSceneContainer extends Component {
  componentDidMount() {
    if (!this.shouldRenderTip()) {
      this.handleReturn();
      return;
    }
    this.props.dispatch(tipActionCreators.getEnergyTips(this.props.placeId));
    gaTrackPageView(ROUTES.ENERGY_ADVISOR_TIPS);
    trackEvent(
      categories.ASESOR_ENERGETICO,
      actions.VISUALIZAR_TIPS,
      `${labels.VISUALIZAR_TIPS_OK} ${this.props.placeText}`
    );
  }

  handleReturn = () => this.props.dispatch(push(ROUTES.ENERGY_ADVISOR));

  shouldRenderTip = () => this.props.placeText && this.props.placeIcon && this.props.placeId;

  handlePressLike = rowData => this.props.dispatch(tipActionCreators.tipToggleLike(rowData));

  render() {
    return (
      <TipsScene
        loading={this.props.tipsLoading}
        tips={this.props.tips}
        placeText={this.props.placeText}
        placeIcon={this.props.placeIcon}
        onPressLike={this.handlePressLike}
        handleReturn={this.handleReturn}
      />
    );
  }
}

const mapStateToProps = (store, ownProps) => ({
  tips: store.tip.tips,
  tipsLoading: store.tip.tipsLoading,
  placeId: ownProps.location.params && ownProps.location.params.placeId,
  placeText: ownProps.location.params && ownProps.location.params.placeText,
  placeIcon: ownProps.location.params && ownProps.location.params.icon
});

TipsSceneContainer.propTypes = {
  tips: PropTypes.arrayOf(PropTypes.shape(tipPropTypes)).isRequired,
  placeId: PropTypes.number,
  placeText: PropTypes.string,
  placeIcon: PropTypes.string,
  tipsLoading: PropTypes.bool
};

export default connect(mapStateToProps)(TipsSceneContainer);
